module.exports = __webpack_public_path__ + "img/lock.c7984557.svg";